import TagsPill from './widgets/header/TagsPill.vue';
import ConversationStatusPill from './widgets/header/ConversationStatusPill.vue';
import AutopilotPill from './widgets/header/AutopilotPill.vue';
import MessageReactions from './widgets/decorators/MessageReactions.vue';
import WindowIndicator from './widgets/decorators/WindowIndicator.vue';
import CrmPanel from './widgets/panel/CrmPanel.vue';

export default {
  'header-actions': [
    { component: TagsPill, order: 10, mobile: false },
    { component: ConversationStatusPill, order: 20, mobile: false },
    { component: AutopilotPill, order: 30, mobile: false },
  ],
  'message-decorators': [
    { component: MessageReactions, order: 10, mobile: true },
  ],
  'card-decorators': [
    { component: WindowIndicator, order: 10, mobile: true },
  ],
  'conversation-panel': [
    { component: CrmPanel, order: 10, mobile: true },
  ],
  'conversation-menu': [],
  'message-menu': [],
  'sidebar-nav': [],
  'attachment-menu': [],
};
